<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppBreadcrumb from '@/components/AppBreadcrumb.vue'

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    default: ''
  },
  icon: {
    type: String,
    default: null
  }
})

// Where this page stands (see router/index.js): empty for the pages whose route does not say, which
// is how those keep their header without a breadcrumb.
const route = useRoute()

const breadcrumb = computed(() => route.meta.breadcrumb ?? [])

const firstLineSubtitle = computed(() => {
  if (!props.subtitle) return ''
  return props.subtitle.split('\n')[0]
})
</script>


<template>
  <v-row>
    <v-col cols="12">
      <AppBreadcrumb :steps="breadcrumb" :current="title" />
      <div class="d-flex align-center my-2 flex-wrap">
        <v-icon v-if="icon" size="40" class="mr-4" color="primary">{{ icon }}</v-icon>
        <div>
          <h1><slot name="title">{{ title }}</slot></h1>
          <p v-if="firstLineSubtitle" class="text-subtitle-1 text-medium-emphasis mt-1 mb-0">{{ firstLineSubtitle }}</p>

          <!-- Free content under the title (the titles of a player, secondary info, ...). -->
          <slot name="below-title" />
        </div>

        <!-- Extra content next to the title (the state of an event, ...). -->
        <slot name="append" />
      </div>
    </v-col>
  </v-row>
</template>
